import { Faq } from '../FAQ/Faq'
import { File } from '../Filemgt/File'
import { Header } from '../Header/Header'
import { Hero } from '../Hero/Hero'
import { Marketplace } from '../Marketplace/Marketplace'
import { Mplace } from '../Mplace/Mplace'
import { OurDev } from '../OurDev/OurDev'
import { Priceintro } from '../Pricingintro/Priceintro'
import { Secure } from '../Secure/Secure'
import { Service } from '../Services/Service'
import { Slider } from '../Slider/Slider'
import { Footer } from '../Footer/Footer'
import { Pop } from './HandlePop/Pop'
import { Popup } from '../Popup/Popup'
import {FaqPage } from '../FaqPage/FaqPage';
import { Developer } from '../FaqPage/Developer'



export const Home = () => {
  return (
    <div>
        <Header/>
        <Hero/>
        <Priceintro/>
        <Service/>
        <File/>
        <Secure/>
        <Marketplace/>
        <Slider/>
        <OurDev/>
        <Mplace/>
        <Faq/>
      <Popup/>
    <Footer/>

    </div>
  )
}
